import * as angular from "angular";
import {IController} from "angular";

//TODO WARNING> this component was a angularjs directive and was use at the market (deprecated)

export class RouteDetailsCtrl implements IController {
  route: any;
  notAfter: any;

  public dueToday: any;
  public timeWindow: any;

  constructor(private moment) {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.notAfter && !changes.notAfter.isFirstChange()) {
      this.dueToday = this.moment(this.notAfter).isSame(this.moment(), 'day');
      this.timeWindow = {
        start: this.route.notBefore,
        end: this.notAfter
      };

    }
  }


}

angular
  .module('bringoz.admin.routes')
  .component('routeDetails', {
    bindings: {
      route: '<',
      notAfter: '<?'
    },
    template: require('./route-details.html').default,
    controller: RouteDetailsCtrl
  });

